import {
    PRODUCT_PRICING_GET_REQUEST,
    PRODUCT_PRICING_FALLBACK_GET_REQUEST,
    PRODUCT_PRICING_GET_SUCCESS,
    SET_BUNDLE_PRODUCT_PRICING,
} from '../actionTypes/ProductPricingActionTypes';

export const getProductPricingAction = (payload) => ({
    type: PRODUCT_PRICING_GET_REQUEST,
    payload,
});

export const getProductPricingFallbackAction = (payload) => ({
    type: PRODUCT_PRICING_FALLBACK_GET_REQUEST,
    payload,
});

export const clearProductPricingAction = () => ({
    type: PRODUCT_PRICING_GET_SUCCESS,
    pricing: {},
});

export const setBundleProductPricingAction = (payload) => ({
    type: SET_BUNDLE_PRODUCT_PRICING,
    payload,
});
